import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { Spin, Form } from 'antd';

interface FarmLocationData {
  id: string;
  code: string;
  product_name: string;
  location_address: string;
  contact_no: string;
  fax_no: string;
  gps: string;
  status: string;
}

export const FarmLocationDetails: React.FC<{
  farmData: FarmLocationData;
  title: string;
  loading?: boolean;
}> = ({ farmData, title, loading = false }) => {
  if (loading) {
    return (
      <BaseCard title={title}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      </BaseCard>
    );
  }

  return (
    <BaseCard title={title}>
      <Form
        labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
        labelAlign="left"
        labelWrap
        wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
        size="small"
      >
        <BaseRow gutter={[16, 16]}>
          <BaseCol xs={24} md={12}>
            <Form.Item label="Farm Code">
              <span style={{ fontWeight: 'normal' }}>{farmData.code || '-'}</span>
            </Form.Item>
          </BaseCol>

          <BaseCol xs={24} md={12}>
            <Form.Item label="Farm Location Name">
              <span style={{ fontWeight: 'normal' }}>{farmData.product_name || '-'}</span>
            </Form.Item>
          </BaseCol>

          <BaseCol xs={24} md={12}>
            <Form.Item label="Address">
              <span style={{ fontWeight: 'normal' }}>{farmData.location_address || '-'}</span>
            </Form.Item>
          </BaseCol>

          <BaseCol xs={24} md={12}>
            <Form.Item label="Contact No">
              <span style={{ fontWeight: 'normal' }}>{farmData.contact_no || '-'}</span>
            </Form.Item>
          </BaseCol>

          <BaseCol xs={24} md={12}>
            <Form.Item label="Fax">
              <span style={{ fontWeight: 'normal' }}>{farmData.fax_no || '-'}</span>
            </Form.Item>
          </BaseCol>

          <BaseCol xs={24} md={12}>
            <Form.Item label="GPS Location">
              <span style={{ fontWeight: 'normal' }}>{farmData.gps || '-'}</span>
            </Form.Item>
          </BaseCol>

          <BaseCol xs={24} md={12}>
            <Form.Item label="Status">
              <span style={{ fontWeight: 'normal' }}>{farmData.status || '-'}</span>
            </Form.Item>
          </BaseCol>
        </BaseRow>
      </Form>
    </BaseCard>
  );
};
